var _defs, _path, _path2, _circle, _circle2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableGameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "table-games",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.475,
    height: 21.475,
    viewBox: "0 0 21.475 21.475",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1b515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#fffb9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1900b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3731",
    "data-name": "Path 3731",
    d: "M186.964,6.321V0h-6.321V6.321ZM183.8,1.134a2,2,0,1,1-2,2A2,2,0,0,1,183.8,1.134Z",
    transform: "translate(-173.066 0)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3732",
    "data-name": "Path 3732",
    d: "M367.606,6.321V.661A.661.661,0,0,0,366.945,0h-5.66V6.321Z",
    transform: "translate(-346.132)",
    fill: "url(#linear-gradient)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 0.745,
    cy: 0.745,
    r: 0.745,
    transform: "translate(9.993 2.389)",
    fill: "url(#linear-gradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 0.745,
    cy: 0.745,
    r: 0.745,
    transform: "translate(17.638 9.993)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3733",
    "data-name": "Path 3733",
    d: "M367.606,180.643h-6.321v6.321h6.321Zm-3.092,5.161a2,2,0,1,1,2-2A2,2,0,0,1,364.514,185.8Z",
    transform: "translate(-346.132 -173.066)",
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3734",
    "data-name": "Path 3734",
    d: "M180.643,361.286h6.321v6.321h-6.321Z",
    transform: "translate(-173.066 -346.132)",
    fill: "url(#linear-gradient)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3735",
    "data-name": "Path 3735",
    d: "M0,180.643H6.321v6.321H0Z",
    transform: "translate(0 -173.066)",
    fill: "url(#linear-gradient)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3736",
    "data-name": "Path 3736",
    d: "M361.285,361.286v6.321h5.66a.661.661,0,0,0,.661-.661v-5.66Zm4.812,3.925a.628.628,0,1,1-.888.888l-.7-.7-.7.7a.628.628,0,0,1-.888-.888l.7-.7-.7-.7a.628.628,0,1,1,.888-.888l.7.7.7-.7a.628.628,0,0,1,.888.888l-.7.7Z",
    transform: "translate(-346.132 -346.132)",
    fill: "url(#linear-gradient)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3737",
    "data-name": "Path 3737",
    d: "M6.321,6.321V0H.661A.661.661,0,0,0,0,.661v5.66H6.321ZM1.5,2.438a.628.628,0,0,1,.888-.888l.7.7.7-.7a.628.628,0,0,1,.888.888l-.7.7.7.7a.628.628,0,1,1-.888.888l-.7-.7-.7.7A.628.628,0,0,1,1.5,3.83l.7-.7Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3738",
    "data-name": "Path 3738",
    d: "M0,361.286v5.66a.661.661,0,0,0,.661.661h5.66v-6.321Z",
    transform: "translate(0 -346.132)",
    fill: "url(#linear-gradient)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3739",
    "data-name": "Path 3739",
    d: "M186.964,180.643h-6.321v6.321h6.321v-6.321Zm-1.577,4.744a.628.628,0,0,1-.888,0l-.7-.7-.7.7a.628.628,0,0,1-.888-.888l.7-.7-.7-.7a.628.628,0,1,1,.888-.888l.7.7.7-.7a.628.628,0,1,1,.888.888l-.7.7.7.7A.628.628,0,0,1,185.387,185.387Z",
    transform: "translate(-173.066 -173.066)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableGameIcon);
export default __webpack_public_path__ + "static/media/tableGameIcon.1ce28a85a7257c0110e26ffda7808e54.svg";
export { ForwardRef as ReactComponent };